// The 10 commitment icons, vectorised from the client's own
// "10 Commitments 4.0" infographic and recoloured to the site orange.
// SVG = crisp at any resolution.
export const COMMITMENT_ICON_SRCS = [
  "/icons/commit-01.svg",
  "/icons/commit-02.svg",
  "/icons/commit-03.svg",
  "/icons/commit-04.svg",
  "/icons/commit-05.svg",
  "/icons/commit-06.svg",
  "/icons/commit-07.svg",
  "/icons/commit-08.svg",
  "/icons/commit-09.svg",
  "/icons/commit-10.svg",
];
